import * as React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "@mui/icons-material/Close";
import Heading from "../../Atoms/heading/EventEHRHeading";
import EditEmergencyContact from "./EditEmergencyContact";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    BorderAllRounded: "8px",
    Height: "300px",
    width: "708px", // Set your custom width here
    maxWidth: "none", // Prevents Material-UI from overriding your width
  },
}));

interface EventEHREditEmergencyContactDialogProps {
  isOpen: boolean;
  defaultSelectedData: any;
  dialogHeading: string;
  handleClose: () => void;
  handleSubmittedEmergencyContactData: (data: any) => void;
}

export default function EventEHREditEmergencyContactDialog({
  isOpen = false,
  defaultSelectedData,
  handleClose,
  handleSubmittedEmergencyContactData,
  dialogHeading = "Your Heading Here...",
}: EventEHREditEmergencyContactDialogProps) {
  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
      >
        <div
          className="flex justify-between items-center rounded-lg"
          style={{ margin: "14px 24px" }}
        >
          <Heading title={dialogHeading} />
          <div onClick={handleClose} className="cursor-pointer">
            <CloseIcon />
          </div>
        </div>

        <DialogContent
          dividers
          style={{ padding: "16px 24px 24px 24px", borderRadius: "8px" }}
        >
          <EditEmergencyContact
            defaultSelectedData={defaultSelectedData}
            handleOnSubmittedData={(formData) => {
              handleSubmittedEmergencyContactData(formData);
            }}
            handleClose={handleClose}
          />
        </DialogContent>
      </BootstrapDialog>
    </React.Fragment>
  );
}
